import styled from "styled-components";

export const Video = styled.video`
	min-width: 200px;
	max-width: 100%;
	margin-bottom: 1em;
`;
